import { token } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/token.js?1733898722636';
import { customer } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/customer.js?1733898722636';
import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898722636';
import { guest_cart_name } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/cart.js?1733898722636';
import { save } from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/stores/storage.js?1733898722636';

let logout_timer;
export function customer_logout_action(customer_logged_out = false) {
    save(guest_cart_name, undefined);
    token.set(undefined);
    customer.set(undefined);
    // clear all storage keys
    if (localStorage) {
        localStorage.clear();
    }
    if (sessionStorage) {
        sessionStorage.clear();
    }
    // clear all cookies
    for (const cookie of document.cookie.split(';')) {
        const [key] = cookie.split('=');
        document.cookie = `${key.trim()} =; expires = Thu, 01 Jan 1970 00:00:00 UTC`;
    }
    clearTimeout(logout_timer);
    logout_timer = setTimeout(() => {
        messages.push(window.__(customer_logged_out ? 'customer.logout_success' : 'customer.logout_success_system'), 'success');
    }, 2000);
}
